import { SelectField } from '@hypeit-gmbh/hypeit-ui';
import { FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type RecipientPropsType<T extends FieldValues> = {
  fieldName: Path<T>;
  data: { value: string; label: string }[];
};

export const Recipient = <T extends FieldValues>({
  fieldName,
  data,
}: RecipientPropsType<T>): React.ReactElement => {
  const { t } = useTranslation();
  const hasOptions = data.length > 0;

  return (
    <SelectField<T>
      fieldName={fieldName}
      label={t('REPORTS.MAILING_FORM.RECIPIENT')}
      placeholder={t('REPORTS.MAILING_FORM.RECIPIENT_PLACEHOLDER')}
      data={data}
      disabled={!hasOptions}
      description={
        hasOptions ? undefined : t('REPORTS.MAILING_FORM.RECIPIENT_NO_OPTIONS')
      }
      clearable
      searchable
    />
  );
};
